import { configureStore } from "@reduxjs/toolkit";
import headerReducer from "./headerSlice";
import { useDispatch } from "react-redux";
import AccessRightSlice from "./Access-Right-Slice";
import companyReducer from "./companySlice";

export const store = configureStore({
    reducer: {
        header: headerReducer,
        AccessRight: AccessRightSlice,
        company: companyReducer
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export const useAppDispatch = () => useDispatch<AppDispatch>();